import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import { TextField as TextFieldUI } from "@material-ui/core";
import useStyles from "./useStyles";
import Autocomplete from "@material-ui/lab/Autocomplete";

function AutocompleteField({
    fieldName,
    type,
    helperText,
    options,
    getOptionLabel,
    renderOption,
    valueKey,
    labelKey,
    onChange,
    multiple,
    limitTags,
    getOptionSelected,
    ...rest
}) {
    const classes = useStyles();

    function getOptionLabelHandler() {
        if (getOptionLabel) {
            return getOptionLabel;
        } else {
            return (option) => {
                if (option) {
                    const value = option[valueKey];
                    const label = option[labelKey];
                    if (value && label) {
                        return `(${value}) ${label}`;
                    }

                    return "";
                }

                return "";
            };
        }
    }

    function renderOptionHandler() {
        if (renderOption) {
            return renderOption;
        } else {
            return (option) => <React.Fragment>{getOptionLabelHandler()(option)}</React.Fragment>;
        }
    }

    return (
        <Field type={type} name={fieldName}>
            {({ field, form: { touched, errors, setFieldValue } }) => (
                <Autocomplete
                    multiple={multiple}
                    limitTags={limitTags}
                    disabled={rest.disabled}
                    className={classes.autocomplete}
                    options={options}
                    classes={{
                        option: classes.option,
                    }}
                    autoHighlight
                    getOptionLabel={getOptionLabelHandler()}
                    renderOption={renderOptionHandler()}
                    onChange={(e, v, r) => {
                        setFieldValue(field.name, v);
                        onChange && typeof onChange === "function" && onChange({ fieldName, value: v });
                    }}
                    value={field.value}
                    renderInput={(params) => (
                        <TextFieldUI
                            {...params}
                            {...rest}
                            name={field.name}
                            type={type}
                            helperText={touched[fieldName] ? errors[fieldName] : helperText}
                            error={Boolean(touched[field.name]) && Boolean(errors[field.name])}
                            inputProps={{
                                ...params.inputProps,
                                autoComplete: "off", // disable autocomplete and autofill
                            }}
                        />
                    )}
                    getOptionSelected={getOptionSelected}
                />
            )}
        </Field>
    );
}

AutocompleteField.propTypes = {
    fieldName: PropTypes.string.isRequired,
    type: PropTypes.string,
    variant: PropTypes.string,
    size: PropTypes.string,
    margin: PropTypes.string,
    fullWidth: PropTypes.bool,
    helperText: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getOptionLabel: PropTypes.func,
    renderOption: PropTypes.func,
    valueKey: PropTypes.string,
    labelKey: PropTypes.string,
    onChange: PropTypes.func,
    getOptionSelected: PropTypes.func,
};

AutocompleteField.defaultProps = {
    type: "text",
    variant: "outlined",
    size: "small",
    margin: "normal",
    fullWidth: true,
    helperText: undefined,
    getOptionLabel: undefined,
    renderOption: undefined,
    valueKey: "value",
    labelKey: "label",
    onChange: undefined,
    getOptionSelected: undefined,
};

export default AutocompleteField;
